export default {
  state: {
    repositoryFilesList: {}
  },
  mutations: {
    addFilesToList(state, payload) {
      state.repositoryFilesList = payload;
    }
  },
  actions: {
    getRepositoryFiles(state, payload) {
      state.commit('addFilesToList', payload);
    }
  },
  getters: {
    getFilesList(state) {
      return state.repositoryFilesList;
    }
  }
};
